import { useLocation } from 'react-router-dom';
import { useCallback } from 'react';

import { Theme } from '@app-types/theme.type';
import { generateUUID } from '@utils/uuid.util';
import { useRemoteConfig } from '@hooks/remote-config';

import MenuLink from '../menu-link/menu-link.component';
import LogoutIcon from '../../icons/logout.icon';
import PanaIcon from '../../assets/img/pana-icon.svg';

import { coreNavItems, quickAccessNavItems } from './menu-item-config';
import styles from './menu.module.scss';

interface Props {
    theme?: Theme;
    onLogout: () => void;
}

const Menu = (props: Props) => {
    const location = useLocation();
    const { getRemoteValue } = useRemoteConfig();

    const isCurrentPath = (path: string) => {
        const currentPath = location.pathname;
        return currentPath === path;
    };

    const isEnabled = useCallback(
        (featureFlag?: string) => {
            return featureFlag ? getRemoteValue(featureFlag) : true;
        },
        [getRemoteValue]
    );

    return (
        <nav className={styles.menu}>
            <header className={'flex align-center'}>
                <img src={PanaIcon} alt={'pana-icon'} />
                <h3>Backoffice</h3>
            </header>
            <section className={styles.coreNav}>
                <ul>
                    {coreNavItems.map((item) => (
                        <MenuLink
                            key={generateUUID()}
                            here={isCurrentPath(item.path)}
                            path={item.path}
                            icon={item.icon}
                            label={item.label}
                            isEnabled={isEnabled(item.featureFlag)}
                        />
                    ))}
                </ul>
            </section>
            <section>
                <h4>Acceso rápido</h4>
                <ul>
                    {quickAccessNavItems.map((item) => (
                        <MenuLink
                            key={generateUUID()}
                            here={isCurrentPath(item.path)}
                            path={item.path}
                            icon={item.icon}
                            label={item.label}
                            isEnabled={isEnabled(item.featureFlag)}
                        />
                    ))}
                </ul>
            </section>
            <footer>
                <button
                    className={styles.logoutButton}
                    onClick={props.onLogout}
                >
                    <LogoutIcon size={18} />
                    <span>Cerrar sesión</span>
                </button>
            </footer>
        </nav>
    );
};

export default Menu;
